import { Component, OnInit } from "@angular/core";

import { TaskService } from "../tasks/shared/task.service";
import { Task } from "../tasks/shared/task.model";

@Component({
    selector: 'dashboard',
    templateUrl: './dashboard.component.html'
    
})

export class DashboardComponent {

    public tasks: Task[];

    /**
     * constructor
     */
    public constructor(private taskService: TaskService) {
        //this.taskService.getTasks().then((tasks) => console.log(tasks));
    }

    /**
     * ngOnInit
     */
    public ngOnInit() {
        this.taskService.getImportant()
            .subscribe(
                tasks => this.tasks = tasks,
                error => alert("Erro dashboard!")
            );
         
    }

}


// WEBPACK FOOTER //
// C:/xampp2/htdocs/angular-front/src/app/dashboard/dashboard.component.ts